// extracted by mini-css-extract-plugin
export default {"container":"SettingsBlock_container__+z5u+","container_small":"SettingsBlock_container_small__Yl3Bd","children_block":"SettingsBlock_children_block__BxPj8"};